import { Components, Theme } from "@mui/material";
import { CustomPalette } from "./palette";

export default {
  MuiTableContainer: {
    styleOverrides: {
      root: {
        boxShadow: "none",
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: "10px 10px 10px 0",
        fontWeight: 500,
        "&:last-child": {
          padding: "10px 0",
          textAlign: "right"
        }
      },
      head: {
        textTransform: "uppercase",
        color: CustomPalette.secondary.main,
        fontWeight: 600,
        fontSize: 12,
        lineHeight: "12px",
        border: "none",
        padding: 0,
      }
    }
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        "&:last-child td": {
          borderBottom: "1px solid  rgba(224, 224, 224, 1)!important"
        }
      }
    }
  }
} as Components<Omit<Theme, "components">>;
